import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import MainPage from '@/components/MainPage'
import { installLangMixin } from './shared/langMixin'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.config.productionTip = false
Vue.use(VueRouter)
installLangMixin()

// 除主页外的其它页面（如 kr_view）仍由完整的 SPA（app.html）承载，
// 这里整页跳转过去，避免把全部展馆组件也打进这个独立入口
const router = new VueRouter({
  mode: 'hash',
  routes: [
    { path: '/', name: 'main', component: MainPage },
    {
      path: '/kr_view',
      name: 'kr_view',
      beforeEnter(to) {
        const query = new URLSearchParams(to.query).toString()
        window.location.href = './app.html#/kr_view' + (query ? '?' + query : '')
      }
    },
    { path: '*', redirect: { name: 'main' } }
  ]
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
